<template>
    <v-app>
        <router-view></router-view>

        <!-- This popup is displayed automatically if PWA found new updates -->
        <v-dialog v-model="showDialog" persistent max-width="500">
            <v-card class="rounded-4">
                <v-toolbar flat height="45px">
                    <span class="font-weight-bold subheading">{{ dialogTitle }}</span>
                </v-toolbar>
                <v-progress-linear v-if="!showConfirm" indeterminate height="2" class="mt-0"></v-progress-linear>
                <v-card-text class="text-xs-center">
                    <div v-html="dialogMessage"></div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="confirmDialog" v-if="showConfirm">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>
<script>
export default {
    name: 'app',
    data () {
        return {
            showDialog: false,
            dialogTitle: '',
            dialogMessage: '',
            showConfirm: false
        }
    },
    metaInfo: {
        title: 'SweldoNow',
        titleTemplate: '%s | SweldoNow',
        meta: [
            { charset: 'utf-8' },
            {
                name: 'description',
                content: 'Product description, Personalize, Attendance Tracking, Project Planning & Scheduling, Team Collaboration, Integration, Legal, Contact Us, Support'
            },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    methods: {
    confirmDialog () {
        this.showDialog = false
            if (window.__onUpdateConfirm) {
                window.__onUpdateConfirm()
                window.__onUpdateConfirm = null // clear after use
            }
        }
    },
    created () {
        // Global method to display update dialog
        window.__showUpdateDownloading = (title, message) => {
            this.dialogTitle = title
            this.dialogMessage = message
            this.showConfirm = !!window.__onUpdateConfirm
            this.showDialog = true
        }
    }
}
</script>
